var getFunctionName = require('./getFunctionName');

function replacer(key, value) {
  if (typeof value === 'function') {
    return getFunctionName(value);
  }
  return value;
}

module.exports = function stringify(x) {
  try { // handle "Converting circular structure to JSON" error
    return JSON.stringify(x, replacer, 2);
  }
  catch (e) {
    return String(x);
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/stringify.js
 ** module id = 8
 ** module chunks = 0
 **/